<template>
      <!-- Start -->
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 text-center">
                        <div class="video-solution-cta position-relative" style="z-index: 1;">
                            <div class="position-relative">
                                <img src="../../assets/images/bg/01.jpg" class="img-fluid rounded-md shadow-lg" alt="">
                                <div class="play-icon">
                                    <a @click="toggle" data-type="youtube" data-id="yba7hPeTSjk" class="play-btn lightbox video-play-icon">
                                        <i class="mdi mdi-play text-primary rounded-circle bg-white title-bg-dark shadow-lg"></i>
                                    </a>
                                </div>
                            </div>

                            <div class="content">
                                <div class="row" id="counter">
                                    <div class="col-md-4 mt-4 pt-2">
                                        <div class="counter-box text-center">
                                            <h1 class="mt-3 text-white title-dark d-flex justify-content-center"><count-up class="counter-value" :start-val="10" :end-val="99"></count-up>%</h1>
                                            <h5 class="counter-head text-white title-dark mb-1">Positive feedback</h5>
                                            <p class="text-white-50 mb-0">From Doctors</p>
                                        </div><!--end counter box-->
                                    </div><!--end col-->
                
                                    <div class="col-md-4 mt-4 pt-2">
                                        <div class="counter-box text-center">
                                            <h1 class="mt-3 text-white title-dark d-flex justify-content-center"><count-up class="counter-value" :start-val="2" :end-val="25"></count-up>+</h1>
                                            <h5 class="counter-head text-white title-dark mb-1">Experienced Clinics</h5>
                                            <p class="text-white-50 mb-0">High Qualified</p>
                                        </div><!--end counter box-->
                                    </div><!--end col-->
                
                                    <div class="col-md-4 mt-4 pt-2">
                                        <div class="counter-box text-center">
                                            <h1 class="mt-3 text-white title-dark d-flex justify-content-center"><count-up class="counter-value" :start-val="95" :end-val="1251"></count-up>+</h1>
                                            <h5 class="counter-head text-white title-dark mb-1">Questions & Answers</h5>
                                            <p class="text-white-50 mb-0">Your Questions</p>
                                        </div><!--end counter box-->
                                    </div><!--end col-->
                                </div><!--end row-->
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end row -->
                <div class="feature-posts-placeholder bg-primary"></div>
            </div><!--end container-->
        <!-- End -->

        <div :class="isActive === false ? 'position-fixed ' : 'd-none'" class="modal-video" tabindex="-1" role="dialog" area-modal="true" aria-label="You just opened the modal video">
        <div class="modal-video-body">
            <div class="modal-video-inner" >
                <div class="modal-video-movie-wrap" style="">
                    <iframe  width="460" height="230" src="//www.youtube.com/embed/yba7hPeTSjk?mute=1&amp;autoplay=1"
                        frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen="" tabindex="-1">
                    </iframe>
                    <a @click="toggle" class="mdi mdi-close m-3 text-light h4 position-class"> </a>
                </div>
                <div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from 'vue'
import CountUp from 'vue-countup-v3'

const isActive = ref(true)

function toggle(){
    isActive.value = !isActive.value
}
</script>

<style lang="scss" scoped>

</style>